import React from "react";
import { Link } from "react-router-dom";

const Contact = () => (
  <div>
    <header className="main_menu">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-12">
            <nav className="navbar navbar-expand-lg navbar-light">
              <Link className="navbar-brand" to="/">
                {" "}
                <img className="logo" src="img/logo.png" alt="logo" />{" "}
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon" />
              </button>
              <div
                className="collapse navbar-collapse main-menu-item justify-content-end"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav">
                  <li className="nav-item active">
                    <Link className="nav-link" to="/">
                      Home{" "}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/about">
                      About
                    </Link>
                  </li>

                  <li className="nav-item active">
                    <Link className="nav-link" to="/contact">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
    {/* Header part end*/}
    {/* breadcrumb start*/}
    <section className="breadcrumb breadcrumb_bg">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="breadcrumb_iner text-center">
              <div className="breadcrumb_iner_item">
                <h2>Contact us</h2>
                <p>
                  Home<span>-</span>Contact
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="service_part section_padding gray_bg">
      <div className="container">
        <div className="row">
          <div
            className="col-sm-12 col-lg-12 col-xl-12"
            style={{ textAlign: "center" }}
          >
            <div className="single_service_text">
              <h2>Contact Details</h2>
            </div>
          </div>
          <div className="col-sm-6 col-xl-4" style={{ marginTop: 10 }}>
            <div className="single_service_part">
              <h4>Head Office </h4>
              <ul style={{ listStyle: "disc" }}>
                <li style={{ fontSize: 18 }}>
                  {" "}
                  Address: A-969, Indira Nagar Lucknow, 226016
                </li>
                <li style={{ fontSize: 18 }}>Phone: 0522 - 2348245</li>
                <li style={{ fontSize: 18 }}>Phone: 0522 - 2340355</li>
                <li style={{ fontSize: 18 }}>Mail: ho@mucbl.in</li>
              </ul>
              {/* <a href="#" className="btn_3">
                Learn More <i className="ti-arrow-right" />
              </a> */}
            </div>
          </div>
          <div className="col-sm-6 col-xl-4" style={{ marginTop: 10 }}>
            <div className="single_service_part single_service_part_2">
              <h4>Indira Nagar Branch</h4>
              <ul style={{ listStyle: "disc" }}>
                <li style={{ fontSize: 18 }}>
                  {" "}
                  Address: A-969, Indira Nagar Lucknow, 226016
                </li>
                <li style={{ fontSize: 18 }}>Phone: 0522 - 2348245</li>
                <li style={{ fontSize: 18 }}>Phone: 0522 - 2340355</li>
                <li style={{ fontSize: 18 }}>Mail: mucbind@mucbl.in</li>
              </ul>
            </div>
          </div>
          <div className="col-sm-6 col-xl-4" style={{ marginTop: 10 }}>
            <div className="single_service_part single_service_part_2">
              <h4>Transport Nagar Branch</h4>
              <ul style={{ listStyle: "disc" }}>
                <li style={{ fontSize: 18 }}>
                  Address: S-58/10, First Floor, Transport Nagar, Kanpur Road,
                  Lucknow, 226012
                </li>
                <li style={{ fontSize: 18 }}>Phone: 0522 - 2436540</li>
                <li style={{ fontSize: 18 }}>Mail: mucbtpn@mucbl.in</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer className="copyright_part">
      <div className="container">
        <div className="row align-items-center">
          <p className="footer-text m-0 col-lg-8 col-md-12">
            {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
            Copyright MUCB © All rights reserved 2020 | Made with{" "}
            <i className="ti-heart" aria-hidden="true" /> by{" "}
            <a href="https://colorlib.com" target="_blank">
              Colorlib
            </a>{" "}
            in{" "}
            <a
              style={{ color: "#61dafb" }}
              href="https://reactjs.org"
              target="_blank"
            >
              React
            </a>
            {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
          </p>
        </div>
      </div>
    </footer>
  </div>
);

export default Contact;
